import React from "react";
import {
  HeroBannerHighlight,
  HeroBannerContainer,
  HeroBannerTitle,
  HeroBannerTitleContainer,
  HeroBannerWrapper,
} from "../styles/components";

const HeroBannner = () => {
  return (
    <HeroBannerWrapper>
      <HeroBannerContainer>
        <HeroBannerTitleContainer>
          <HeroBannerTitle>
            <HeroBannerHighlight>Hey Texas!</HeroBannerHighlight>
            <br />
            Switching doesn’t
            <br />
            need to be complicated
          </HeroBannerTitle>
        </HeroBannerTitleContainer>
      </HeroBannerContainer>
    </HeroBannerWrapper>
  );
};

export default HeroBannner;
